import {
    FAQ_CREATE,
    FAQ_LIST,
    FAQ_UPDATE
} from "../actions";

export function faq(currentState = {}, action) {
    switch (action.type) {
        case FAQ_CREATE:
            return {
                type: action.type,
                list: currentState.list ? currentState.list.concat(action.list) : [action.list]
            }
        case FAQ_LIST:
            return currentState = action
        case FAQ_UPDATE:
            return {
                type: action.type,
                list:  currentState.list.map(current => current.id  === action.list.id ? action.list : current)
            }
        default:
            return currentState
    }
}